/**
 * Object for keeping track of z-index values, so we can easily know and calculate
 * what component should come above/bellow other components.
 * This z-index should only track components in this (jpu-shared) repository.
 */
export const zIndexReference = {
  Overlay: 1000,
  NavbarContainer: 1500,
  WhateverNeedsToBeOnTopOfEverything: 100_000,
};
